import { render } from "./PrelimVotesDisplayBox.vue?vue&type=template&id=64539c1a"
import script from "./PrelimVotesDisplayBox.vue?vue&type=script&lang=js"
export * from "./PrelimVotesDisplayBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__